import React from 'react'
import Lesson from '../../components/admin/lessons'
export default function Lessons() {
    return (
        <div>
            <Lesson />
        </div>
    )
}
